import React, { useEffect, useState } from "react";
import { Authenticator } from "@aws-amplify/ui-react";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from "react-router-dom";
import Home from "./pages/Home";
import ReportsPage from "./pages/ReportsPage";
//import Premium from "./pages/Premium";
import TopBar from "./components/TopBar";
import SideNavBG from "./images/SideMenuBackground.png";
import Overview from "./pages/Overview";
import ProfilesBar from "./components/ProfilesBar";
// import TestPage from "./pages/TestPage";
import NewReport from "./pages/NewReport";
import NPVCalculator from "./components/NPVCalculator";
import ScorePage from "./pages/ScorePage";
import Resources from "./pages/Resources";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import SuccessPage from "./pages/SuccessPage";
import BalanceSheetPage from "./pages/BalanceSheetPage";
import FailurePage from "./pages/FailurePage";
import MCCalc from "./pages/MCCalc";
import { AcceptLegal } from "./components/AcceptLegal";
import InflationCalculator from "./components/InflationCalculator";
import { EditAccount } from "./pages/EditAccount";
import GetDomainRoot from "./Utils/GetDomainRoot";
const myReq = require("./Requests.js");

let userNameKey = "";

function App({ signOut, user }) {
  const [isLoading, setIsLoading] = useState(true);
  const [DevMode, setDevmode] = useState(false);
  const [QDBLoading, setQDBLoading] = useState(true);
  const [QDB, setQDB] = useState([]);
  const [Quotes, setQuotes] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [activeProfile, setActiveProfile] = useState("");
  const [activeProfileIdx, setAPIdx] = useState(0);
  const [open, setOpen] = useState(false);
  const [whitelabels, setWhiteLabels] = useState([]);
  const [logoUrl, setLogoUrl] = useState();
  const closeModal = () => setOpen(false);
  const Subscribed =
    profileData.Subscribed === undefined
      ? false
      : profileData.Subscribed.Active === undefined
      ? false
      : profileData.Subscribed.Active;
  userNameKey = user.username;
  //console.log("app: " + userNameKey);
  function checkForProfiles() {
    // window.location.href = "/";
    myReq.setActiveProfReq(userNameKey, profileData.Profiles.length, () => {
      // console.log("this is where we normally refresh");
      window.location.href = "/";
    });
  }
  /* function loadNewProfile(data) {
    setProfileData(data);
  }*/

  function getPaidList(data) {
    for (let index = 0; index < data.Profiles.length; index++) {
      const profile = data.Profiles[index];
      let ScoreHistory = profile.History;

      if (ScoreHistory !== undefined) {
        data.Profiles[index].paidHistory = {};
        for (let i = 0; i < Object.keys(ScoreHistory).length; i++) {
          const key = Object.keys(ScoreHistory)[i];
          const element = ScoreHistory[key];

          if (element.paid !== false) {
            data.Profiles[index].paidHistory[key] = element;
          }
        }
      }
    }
    return data;
  }

  useEffect(() => {
    //#region loadAPIs
    setIsLoading(true);
    setQDBLoading(true);
    let currentDomain = GetDomainRoot(window.location.href);
    //Question Database
    myReq.getQDBReq((res) => {
      // console.log("res.body :>> ", JSON.parse(res.body));
      let parsed = JSON.parse(res.body);
      let quoteCache = parsed.tables.find(
        (item) => item.TableID === "Quotes"
      ).dataRows;
      setWhiteLabels(parsed.whitelabels);
      // console.log("whitelabels :>> ", whitelabels);
      let wlCache = parsed.whitelabels.find((item) =>
        item.Domain.includes(currentDomain)
      );
      setQDB(parsed.qdb);
      // console.log("currentDomain :>> ", currentDomain);
      // console.log("parsed :>> ", parsed);
      if (wlCache.Logos != undefined) {
        setLogoUrl(wlCache.Logos);
        // console.log("logoUrl :>> ", logoUrl);
      }
      // console.log("wlCache.Logos :>> ", wlCache.Logos);
      setQuotes(quoteCache);
      setQDBLoading(false);
      // console.log("quotes :>> ", Quotes);
    });
    //UserData
    // console.log("userNameKey :>> ", userNameKey);
    myReq.getProfileReq(userNameKey, (data) => {
      setProfileData(data);
      if (data.Settings !== undefined) {
        let currentDomain = GetDomainRoot(data.Settings.signUpSite);
        let wlCache = whitelabels.find((item) =>
          item.Domain.includes(currentDomain)
        );
        if (wlCache !== undefined) {
          setWhiteLabels(wlCache.Logos);
        }
      }
      if (data.Profiles) {
        // console.log("data :>> ", data);
        data = getPaidList(data);
        let loadedProfile;
        if (data.LastActive !== undefined) {
          loadedProfile = data.Profiles[data.LastActive];
          setAPIdx(data.LastActive);
        } else {
          loadedProfile = data.Profiles[0];
          setAPIdx(0);
        }
        //console.log("data :>> ", data);
        // console.log(
        //   "paidHistory :>> ",
        //   paidHistory,
        //   Object.keys(paidHistory).length
        // );
        setActiveProfile(loadedProfile);
        // console.log("loadedProfile :>> ", loadedProfile);
      } else {
        setProfileData("");
      }
      setIsLoading(false);
    });
    //#region set favIcon
    setfavIcon();
    //#endregion setfavIcon
  }, [user.username]);

  function setfavIcon() {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href =
      logoUrl === undefined ? "/icons/QFP_favicon.png" : logoUrl.favicon;
  }

  // console.log("QDB :>> ", QDB);
  function SetProfile(prof) {
    let index = profileData.Profiles.findIndex((object) => {
      return object.Name === prof.Name;
    });

    if (window.location.href.toString().includes("score")) {
      myReq.setActiveProfReq(userNameKey, index, () => {
        window.location.href = "/";
      });
    } else {
      myReq.setActiveProfReq(userNameKey, index, () => {
        setActiveProfile(prof);
      });
      setAPIdx(index);
    }
  }

  function signOutHandler() {
    // console.log("modal open");
    setOpen(true);
  }

  function toggleDev() {
    setDevmode(!DevMode);
  }

  if (isLoading === true || QDBLoading === true) {
    return (
      <div className="App">
        <TopBar logo={logoUrl} />
        <div className="content_block">
          <Authenticator>
            {({ signOut }) => (
              <div>
                <h1>Please wait while we fetch your data</h1>
                <h3>Loading...</h3>
                <br />
                {/* <br />
                <button onClick={signOut} className="userActionButton hoverBox">
                  Sign Out
                </button> */}
              </div>
            )}
          </Authenticator>
        </div>
      </div>
    );
  }

  if (profileData === "") {
    const newProf = localStorage.getItem(`${user.attributes.email} accepted`);

    return (
      <div className="App">
        <TopBar logo={logoUrl} />
        <div className="content_block">
          <div
            className="sidenav"
            style={{ backgroundImage: `url(${SideNavBG})` }}
          ></div>

          <div className="main">
            <Authenticator>
              <AcceptLegal
                email={user.attributes.email}
                new={newProf === "false" || newProf === null}
              />
              <h1>Hello and Welcome</h1>
              <p>
                You've successfully logged in as {user.attributes.email}, but
                you currently have no active profiles.
              </p>
              <Home
                QDB={QDB}
                user={user}
                userNameKey={userNameKey}
                afterSubmit={checkForProfiles}
                new={true}
              />
              <br />
              <button onClick={signOut} className="userActionButton hoverBox">
                Sign Out
              </button>
            </Authenticator>
          </div>
        </div>
      </div>
    );
  }
  setfavIcon();
  // console.log("logoUrl :>> ", logoUrl);
  return (
    <div className="App">
      <Router>
        <TopBar logo={logoUrl} />
        <div className="content_block">
          <Authenticator>
            <div className="profileButton">
              <NavLink
                onClick={signOutHandler}
                className="content sidenavlink"
                to=""
              >
                Sign Out
              </NavLink>
            </div>
            <div
              className="sidenav"
              style={{ backgroundImage: `url(${SideNavBG})` }}
            >
              <NavLink
                exact="true"
                className="content sidenavlink thicker"
                to="/newReport"
              >
                New Report
              </NavLink>
              <NavLink exact="true" className="content sidenavlink" to="/">
                Overview
              </NavLink>
              <NavLink className="content sidenavlink" to="/reports">
                Reports
              </NavLink>
              <NavLink className="content sidenavlink" to="/resources">
                Resources
              </NavLink>

              <NavLink className="content sidenavlink" to="/edit">
                Account
              </NavLink>
              {/* <NavLink
                onClick={signOutHandler}
                className="content sidenavlink"
                to=""
              >
                Sign Out
              </NavLink> */}
            </div>

            <div className="main">
              <Routes>
                <Route
                  path="/"
                  element={
                    <Overview
                      user={user}
                      logo={logoUrl}
                      profileData={profileData}
                      activeProfile={activeProfile}
                      Subscribed={Subscribed}
                      userKey={userNameKey}
                      activeProfileIdx={activeProfileIdx}
                      QDB={QDB}
                      Quotes={Quotes}
                      Dev={DevMode}
                    />
                  }
                ></Route>
                <Route
                  path="/reports"
                  element={
                    <ReportsPage
                      profileData={profileData}
                      activeProfile={activeProfile}
                      Dev={DevMode}
                      Subscribed={Subscribed}
                    />
                  }
                ></Route>
                {/* <Route
                  path="/test"
                  element={
                    <TestPage
                      signOut={signOut}
                      QFUserID={userNameKey}
                      profileData={profileData}
                      activeProfile={activeProfile}
                    />
                  }
                /> */}

                <Route
                  path="/MC"
                  element={
                    <MCCalc
                      Dev={DevMode}
                      activeProfile={activeProfile}
                      Subscribed={Subscribed}
                    />
                  }
                />

                <Route
                  path="/resources"
                  element={<Resources Subscribed={Subscribed} Dev={DevMode} />}
                />
                <Route
                  path="/inflation"
                  element={
                    <InflationCalculator
                      Dev={DevMode}
                      Subscribed={Subscribed}
                    ></InflationCalculator>
                  }
                />
                <Route
                  path="/edit"
                  element={
                    <EditAccount
                      profileData={profileData}
                      activeProfile={activeProfile}
                      Dev={DevMode}
                      user={user}
                      userNameKey={userNameKey}
                      afterSubmit={checkForProfiles}
                      QDB={QDB}
                      signOut={signOut}
                    />
                  }
                />
                <Route
                  path="/newReport"
                  element={
                    <NewReport
                      profileData={profileData}
                      activeProfile={activeProfile}
                      user={user}
                      userKey={userNameKey}
                      QDB={QDB}
                      Dev={DevMode}
                    />
                  }
                />
                <Route
                  path="/score/:scoreObj"
                  element={
                    <ScorePage
                      logo={logoUrl}
                      profileData={profileData}
                      userKey={userNameKey}
                      activeProfileIdx={activeProfileIdx}
                      activeProfile={activeProfile}
                      Subscribed={Subscribed}
                      Quotes={Quotes}
                      Dev={DevMode}
                    />
                  }
                ></Route>

                <Route
                  path="/addProfile"
                  element={
                    <Home
                      user={user}
                      userNameKey={userNameKey}
                      afterSubmit={checkForProfiles}
                      profileData={profileData}
                      QDB={QDB}
                      Dev={DevMode}
                    />
                  }
                ></Route>
                <Route
                  path="/BalanceSheet"
                  element={
                    <BalanceSheetPage
                      userKey={userNameKey}
                      activeProfileIdx={activeProfileIdx}
                      History={activeProfile.paidHistory}
                      Subscribed={Subscribed}
                    />
                  }
                ></Route>
                <Route
                  path="/NPVtest"
                  element={<NPVCalculator Subscribed={Subscribed} />}
                ></Route>
                <Route path="/Success" element={<SuccessPage />}></Route>
                <Route path="/Failure" element={<FailurePage />}></Route>
              </Routes>
            </div>

            <ProfilesBar
              profileData={profileData}
              activeProfile={activeProfile}
              SetProfile={SetProfile}
            ></ProfilesBar>
          </Authenticator>
        </div>
        {window.location.hostname.includes("test") ||
        window.location.href.includes("localhost") ? (
          <div className=" NewProfileButton devButton " onClick={toggleDev}>
            Turn developer {DevMode ? "off" : "on"} mode<br></br>
          </div>
        ) : (
          ""
        )}
        <Popup open={open} onClose={closeModal}>
          <div className="header"> Are you sure? </div>
          <div className="modal_content">
            Are you sure you would like to sign out?
          </div>
          <div className="actions">
            <div
              className="divButton modalButton"
              onClick={() => {
                closeModal();
              }}
            >
              No
            </div>
            <div
              className="divButton modalButton"
              onClick={() => {
                closeModal();
                signOut();
              }}
            >
              Yes
            </div>
          </div>
        </Popup>
      </Router>
    </div>
  );
}
/*
<button onClick={signOut} className="userActionButton hoverBox">
Sign Out
</button>*/
export default withAuthenticator(App);
